import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize, shadow } = theme.tokens;

  return {
    card: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: 12,
      minHeight: 64,
      padding: "12px 16px",
      paddingRight: 44,
      borderRadius: radius.tile,
      backgroundColor: color.bg,
      boxShadow: shadow.hairline,
      cursor: "pointer",
      boxSizing: "border-box",
      transition: "box-shadow .15s",
      "&:hover": { boxShadow: `inset 0 0 0 1px ${color.lineStrong}` },
      "&:focus-within": {
        outline: `2px solid ${color.brand}`,
        outlineOffset: 2
      }
    },
    checked: {
      boxShadow: shadow.selected,
      "&:hover": { boxShadow: shadow.selected }
    },
    unavailable: {
      backgroundColor: color.surface,
      boxShadow: "none",
      cursor: "not-allowed",
      "& $title, & $meta": { color: color.muted },
      "&:hover": { boxShadow: "none" }
    },
    radio: {
      position: "absolute",
      opacity: 0,
      width: 1,
      height: 1,
      margin: 0,
      pointerEvents: "none"
    },
    icon: {
      width: 40,
      height: 40,
      flex: "none",
      borderRadius: radius.pill,
      backgroundColor: color.surface,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& svg": { fontSize: theme.tokens.iconSize.md }
    },
    body: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      minWidth: 0,
      flex: 1
    },
    title: {
      fontSize: fontSize.body,
      fontWeight: 700,
      color: color.ink
    },
    meta: {
      fontSize: fontSize.small,
      color: color.muted
    },
    full: {
      fontSize: fontSize.small,
      fontWeight: 700,
      color: color.muted
    },
    check: {
      position: "absolute",
      top: "50%",
      right: 14,
      transform: "translateY(-50%)",
      width: 22,
      height: 22,
      borderRadius: radius.pill,
      backgroundColor: color.ink,
      color: color.bg,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});

export default withCustomStyles;
